export default __webpack_public_path__ + "static/media/login-illustration.d91718d1.png";